import { PocMenu } from 'commons/components/components-wrapper';
import styled, { css } from 'styled-components';

export const PopoverMenuStyled = styled(PocMenu)<{ $disableScroll?: boolean }>`
    ${({ $disableScroll }) =>
        $disableScroll &&
        css`
            /* OWC-OVERRIDE: owc-menu sets an inline max-height (~6 items) on the list; override
               it so the full action list is shown without an inner scrollbar. owc-menu exposes
               no max-height prop in v7.6.0 and the value is inline, so !important is required.
               Revisit on the next @one upgrade. */
            owc-list {
                max-height: none !important;
            }
        `}
`;
